enum NODE_ENV {
    DEVELOP = "develop",
    STAGING = "staging",
    PBE = "beta",
    PRODUCTION = "production",
}

export default NODE_ENV;
